import * as React from "react";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuList from "@mui/material/MenuList";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import { Navigate, useNavigate } from "react-router-dom";
import logo from "./resource/QLogo.png";
import { color } from "@mui/system";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import HomeIcon from "@mui/icons-material/Home";
import SchoolIcon from "@mui/icons-material/School"; // Example icon for Courses
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart"; // Example icon for Products
import MusicNoteIcon from "@mui/icons-material/MusicNote"; // Example icon for Orchestra
import Diversity1Icon from "@mui/icons-material/Diversity1";
import InfoIcon from "@mui/icons-material/Info";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import PlaceIcon from '@mui/icons-material/Place';
import Drawer from "@mui/material/Drawer";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";

const pages = ["Home", "Products"];
 

function Navbar() {
// Separate refs for Courses and Orchestra, this is for the Popper component in big screen tabs
const coursesAnchorRef = React.useRef(null);  
const orchestraAnchorRef = React.useRef(null); 
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [openOrchestraTab, setOpenOrchestraTab] = React.useState(false);
  const [openCoursesTab, setOpenCoursesTab] = React.useState(false)
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);
  const [openSubDrawer, setOpenSubDrawer] = React.useState(true);
  const [openSubDrawerCourses, setOpenSubDrawerCourses] = React.useState(true)

  const handleClickOpenSubDrawer = () => {
    setOpenSubDrawer(!openSubDrawer);
  };

  const handleClickOpenSubDrawerCourses= () =>{
    setOpenSubDrawerCourses(!openSubDrawerCourses)
  }

  const handleDrawerClose = () => {
    setMobileOpen(false);
  };
  const drawerWidth = 240;
  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const navigate = useNavigate();

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = (pagename) => {
    pagename = pagename.toLowerCase();
    console.log(pagename + "nimama");
    if (pagename == "home") {
      navigate("/");
    } else {
      navigate("/" + pagename);
    }
  };

  const handleCloseWhenClickingAway = () => {
    setAnchorElNav(null);
  };

  const handleToggleOrchestraTab = () => {
    setOpenOrchestraTab((prevOpen) => !prevOpen);
  };

  const handleToggleCoursesTab = ()=>{
    setOpenCoursesTab((prevOpenCourses) => !prevOpenCourses);
  }
  
  const handleCloseOrchestraTab = (event) => {
    if (orchestraAnchorRef.current && orchestraAnchorRef.current.contains(event.target)) {
      return;
    }

    setOpenOrchestraTab(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpenOrchestraTab(false);
    } else if (event.key === "Escape") {
      setOpenOrchestraTab(false);
    }
  }

    // return focus to the button when we transitioned from !open -> open for Orchestra tab in large screen
    const prevOpen = React.useRef(openOrchestraTab);
    React.useEffect(() => {
      if (prevOpen.current === true && openOrchestraTab === false) {
        orchestraAnchorRef.current.focus();
      }
  
      prevOpen.current = openOrchestraTab;
    }, [openOrchestraTab]);


    // return focus to the button when we transitioned from !open -> open for Courses tab in large screen
    const prevOpenCourses = React.useRef(openCoursesTab);
    React.useEffect(() => {
      if (prevOpenCourses.current === true && openCoursesTab === false) {
        coursesAnchorRef.current.focus();
      }
  
      prevOpenCourses.current = openCoursesTab;
    }, [openCoursesTab]);

  const handleCloseCoursesTab = (event) => {
    if (coursesAnchorRef.current && coursesAnchorRef.current.contains(event.target)) {
      return;
    }

    setOpenCoursesTab(false);
  };

  function handleListKeyDownCourses(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpenCoursesTab(false);
    } else if (event.key === "Escape") {
      setOpenCoursesTab(false);
    }
  }



  const drawer = (
    <div>
      <Toolbar />
      <List>
        {["Home", "Products"].map((text, index) => (
          <ListItem
            key={text}
            disablePadding
            onClick={() => handleCloseNavMenu(text)}
          >
            <ListItemButton>
              <ListItemIcon>
                {/* Assign specific icons based on index */}
                {index === 0 ? (
                  <HomeIcon style={{ color: "#cc7420" }} />
                ) : index === 1 ? (
                  <ShoppingCartIcon style={{ color: "#cc7420" }} />
                ) : index === 2 ? (
                  <ShoppingCartIcon style={{ color: "#cc7420" }} />
                ) : null}
              </ListItemIcon>
              <ListItemText
                style={{ fontFamily: "Edwin" }}
                disableTypography={true}
                primary={text}
              />
            </ListItemButton>
          </ListItem>
        ))}
        {/* Drawer Section for ExpandMore Courses with subsection Lessons and Locate us */}
        <ListItemButton onClick={handleClickOpenSubDrawerCourses}>
          <ListItemIcon>
            <SchoolIcon style={{ color: "#cc7420" }} />
          </ListItemIcon>
          <ListItemText
            style={{ fontFamily: "Edwin" }}
            disableTypography={true}
            primary="Courses"
          />
          {openSubDrawerCourses ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openSubDrawerCourses} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton sx={{ pl: 4 }}
             onClick={() => navigate("/courses")}
            >
              <ListItemIcon>
                <LibraryBooksIcon style={{ color: "#cc7420" }} />
              </ListItemIcon>
              <ListItemText
                style={{ fontFamily: "Edwin" }}
                disableTypography={true}
                primary="Lessons"
              />
            </ListItemButton>

            <ListItemButton
              sx={{ pl: 4 }}
              onClick={() => navigate("/courses/toapayoh")}
            >
              <ListItemIcon>
                <PlaceIcon style={{ color: "#cc7420" }} />
              </ListItemIcon>
              <ListItemText
                style={{ fontFamily: "Edwin" }}
                disableTypography={true}
                primary="Locate us"
              />
            </ListItemButton>
          </List>
        </Collapse>


        {/* Drawer Section for ExpandMore Orchestra with subsection Join Our Orchestra, About Us and Events */}
        <ListItemButton onClick={handleClickOpenSubDrawer}>
          <ListItemIcon>
            <MusicNoteIcon style={{ color: "#cc7420" }} />
          </ListItemIcon>
          <ListItemText
            style={{ fontFamily: "Edwin" }}
            disableTypography={true}
            primary="Orchestra"
          />
          {openSubDrawer ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={openSubDrawer} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton sx={{ pl: 4 }}
             onClick={() => window.open("https://docs.google.com/forms/d/e/1FAIpQLScJr80TLJvQOlXpQnBGflr40TJzNwDpu-IMqPrbyWqurRRMzw/viewform", "_blank")}
            >
              <ListItemIcon>
                <Diversity1Icon style={{ color: "#cc7420" }} />
              </ListItemIcon>
              <ListItemText
                style={{ fontFamily: "Edwin" }}
                disableTypography={true}
                primary="Join our Orchestra"
              />
            </ListItemButton>

            <ListItemButton
              sx={{ pl: 4 }}
              onClick={() => navigate("/orchestra")}
            >
              <ListItemIcon>
                <InfoIcon style={{ color: "#cc7420" }} />
              </ListItemIcon>
              <ListItemText
                style={{ fontFamily: "Edwin" }}
                disableTypography={true}
                primary="About us"
              />
            </ListItemButton>

            <ListItemButton sx={{ pl: 4 }}
              onClick={() => navigate("/events")}
            >
              <ListItemIcon>
                <EventAvailableIcon style={{ color: "#cc7420" }} />
              </ListItemIcon>
              <ListItemText
                style={{ fontFamily: "Edwin" }}
                disableTypography={true}
                primary="Events"
              />
            </ListItemButton>
          </List>
        </Collapse>
      </List>
    </div>
  );

  return (
    // <AppBar position="static" style={{background:"#282424"}}>
    //Adding position = "static" will cause the appbar to not scale with the screen size
    <AppBar style={{ background: "#282424" }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            <img src={logo} style={{ maxWidth: "70px" }}></img>
          </Typography>

          {/* Drawer Section using hamburger menu icon for mobile device screen */}
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleDrawerToggle}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Drawer
              container={document.body}
              variant="temporary"
              open={mobileOpen}
              onTransitionEnd={handleDrawerTransitionEnd}
              onClose={handleDrawerClose}
              sx={{
                display: { xs: "block", sm: "block" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                },
              }}
              slotProps={{
                root: {
                  keepMounted: true, // Better open performance on mobile.
                },
              }}
              PaperProps={{
                sx: {
                  backgroundColor: "#282424",
                  color: "white",
                },
              }}
            >
              {drawer}
            </Drawer>
          </Box>

          {/* Quindicesima logo for small screen */}
          <Typography
            variant="h5"
            noWrap
            component="a"
            onClick={() => navigate("/")}
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            <img src={logo} style={{ maxWidth: "70px" }}></img>
            {/* LOGO */}
          </Typography>

          {/* This section is for styling menu for big screen  */}
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={() => handleCloseNavMenu(page)}
                sx={{
                  my: 2,
                  color: "white",
                  display: "flex", // Change to flex for better alignment of content
                  alignItems: "center", // Vertically center the text and icon
                  fontFamily: "Edwin",
                }}
              >
                {page}
              </Button>
            ))}

             {/* This section is for the big screen where on pressing Courses tab it shows the Lessons, Locate Us */}
            <Button
              ref={coursesAnchorRef}
              id="composition-button"
              aria-controls={openCoursesTab ? "composition-menu" : undefined}
              aria-expanded={openCoursesTab ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleToggleCoursesTab}
              sx={{
                my: 2,
                color: "white",
                display: "flex", // Use flex for consistent alignment
                alignItems: "center", // Ensure vertical alignment of text and icon
                fontFamily: "Edwin",
              }}
            >
              Courses
              <ExpandMoreIcon />
            </Button>
            <Popper
              open={openCoursesTab}
              anchorEl={coursesAnchorRef.current}  //Correctly anchor to Courses button
              role={undefined}
              placement="bottom-start"
              transition
              disablePortal
            >
            {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom-start" ? "left top" : "left bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleCloseCoursesTab}>
                      <MenuList
                        autoFocusItem={openCoursesTab}
                        id="composition-menu"
                        aria-labelledby="composition-button"
                        onKeyDown={handleListKeyDownCourses}
                        sx={{ backgroundColor: "#282424" }}
                      >
                        <MenuItem
                          onClick={() =>  navigate("/courses")}
                          sx={{ color: "white", fontFamily: "Edwin" }}
                        >
                          Lessons
                        </MenuItem>
                        <MenuItem
                          onClick={() => navigate("/courses/toapayoh")}
                          sx={{ color: "white", fontFamily: "Edwin" }}
                        >
                          Locate Us
                        </MenuItem>
                        </MenuList>
                        </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
            
            
            
            {/* This section is for the big screen where on pressing Orchestra tab it shows the Join, About Us and Events */}
            <Button
              ref={orchestraAnchorRef}
              id="composition-button"
              aria-controls={openOrchestraTab ? "composition-menu" : undefined}
              aria-expanded={openOrchestraTab ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleToggleOrchestraTab}
              sx={{
                my: 2,
                color: "white",
                display: "flex", // Use flex for consistent alignment
                alignItems: "center", // Ensure vertical alignment of text and icon
                fontFamily: "Edwin",
              }}
            >
              Orchestra
              <ExpandMoreIcon />
            </Button>
            <Popper
              open={openOrchestraTab}
              anchorEl={orchestraAnchorRef.current}  // Correctly anchor to Orchestra button
              role={undefined}
              placement="bottom-start"
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom-start" ? "left top" : "left bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleCloseOrchestraTab}>
                      <MenuList
                        autoFocusItem={openOrchestraTab}
                        id="composition-menu"
                        aria-labelledby="composition-button"
                        onKeyDown={handleListKeyDown}
                        sx={{ backgroundColor: "#282424" }}
                      >
                        <MenuItem
                          onClick={() =>  window.open("https://docs.google.com/forms/d/e/1FAIpQLScJr80TLJvQOlXpQnBGflr40TJzNwDpu-IMqPrbyWqurRRMzw/viewform", "_blank")}
                          sx={{ color: "white", fontFamily: "Edwin" }}
                        >
                          Join our Orchestra
                        </MenuItem>
                        <MenuItem
                          onClick={() => navigate("/orchestra")}
                          sx={{ color: "white", fontFamily: "Edwin" }}
                        >
                          About us
                        </MenuItem>
                        <MenuItem
                         onClick={() => navigate("/events")}
                          sx={{ color: "white", fontFamily: "Edwin" }}
                        >
                          Events
                        </MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Button
              variant="contained"
              color="primary"
              sx={{ fontFamily: "Edwin", background: "#9b51e0" }}
              onClick={() => navigate("/booktrial")}
            >
              BOOK A FREE TRIAL
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Navbar;
